import React from "react";

export default function ConfirmDeleteModal({ open, onClose, onConfirm }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-2xl shadow-lg max-w-md w-full p-6 text-center relative">
        <button
          className="absolute left-4 top-4 text-gray-400 hover:text-gray-600 text-2xl"
          onClick={onClose}
          aria-label="إغلاق"
        >
          ×
        </button>
        <div className="flex flex-col items-center gap-2 mb-4">
          <div className="w-10 h-10 flex items-center justify-center rounded-full bg-red-100 mb-2">
            <span className="text-red-600 text-2xl">!</span>
          </div>
          <h2 className="text-xl font-bold text-[#1D2035]">
            <span className=" decoration-red-500">حذف المحتوى</span>
          </h2>
        </div>
        <p className="text-gray-700 mb-6">
          عند تأكيد الحذف، سيتم إزالة السؤال من التطبيق ولن يكون متاحًا للمستخدمين، ولكن سيظل محفوظًا في سجل النظام للمراجعة إن لزم الأمر.
        </p>
        <div className="flex gap-4 justify-center">
          <button
            className="flex-1 py-2 rounded-lg border border-gray-300 bg-white text-gray-700 font-semibold"
            onClick={onClose}
          >
            عدم الحذف
          </button>
          <button
            className="flex-1 py-2 rounded-lg bg-[#7A1313] text-white font-semibold"
            onClick={onConfirm}
          >
            حذف
          </button>
        </div>
      </div>
    </div>
  );
}
